import { CommonModule } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';
import { MatTabsModule, MatTabHeaderPosition } from '@angular/material/tabs';
import { getProjectionCode, ProjectionCode } from '@models/leaflet';
import geojson from 'geojson';
import { LeafletComponent } from '../leaflet.component';

@Component({
  selector: 'app-leaflet-group',
  templateUrl: './group.component.html',
  styleUrls: ['./group.component.scss'],
  imports: [CommonModule, MatTabsModule, LeafletComponent],
})
export class LeafletGroupComponent {
  readonly ProjectionCode = ProjectionCode;
  readonly projectionLabels = new Map([
    [ProjectionCode.Arctic, 'EPSG:3995 - Arctic Polar Stereographic'],
    [ProjectionCode.Mercator, 'EPSG:3857 - Pseudo-Mercator'],
    [ProjectionCode.Antarctic, 'EPSG:3031 - Antarctic Polar Stereographic'],
  ]);

  public headerPosition = input('above' as MatTabHeaderPosition);
  public height = input('400px');

  geometry = input<geojson.FeatureCollection>();
  readonly = input(true);
  geometryChange = output<geojson.FeatureCollection>();

  featuresCount = computed(() => {
    const result = {
      [ProjectionCode.Arctic]: 0,
      [ProjectionCode.Mercator]: 0,
      [ProjectionCode.Antarctic]: 0,
    };

    const geometry = this.geometry();
    if (!geometry?.features) {
      return result;
    }

    for (const feature of geometry.features) {
      const code = getProjectionCode(feature);
      result[code] += 1;
    }

    return result;
  });

  projections = computed(() => {
    const allProjections = Array.from(this.projectionLabels.keys());
    if (!this.readonly()) {
      return allProjections;
    }

    const geometry = this.geometry();
    if (!geometry?.features) {
      return [];
    }

    const projections = [];
    for (const projection of allProjections) {
      if (this.featuresCount()[projection] == 0) {
        continue;
      }

      projections.push(projection);
    }

    return projections;
  });
}
